import { Route, Routes } from '@angular/router';
import { createFeatureToggleAuthGuardsPerRoute } from '@cde-fe-app/app/shared/utils/nav-items';
import { CallbackComponent } from './shared/components/callback/callback.component';
import { ServerErrorComponent } from './shared/components/server-error/server-error.component';
import { canLoadAginConnectionManagerRouteGuard } from './shared/guard/agin-connection-manager.guard';

function createRoute(path: string, loadChildren: Promise<Route | Routes>) {
  return {
    path,
    // for future reference: To disable lazy loading just include the routes here like this
    // children: MACHINE_ROUTES,
    loadChildren: () => loadChildren,
    canActivate: createFeatureToggleAuthGuardsPerRoute(path),
  } as Route;
}

export const APP_ROUTES: Routes = [
  { path: 'callback', component: CallbackComponent },
  createRoute(
    'logoutCallback',
    import('./features/dashboard/dashboard-routing').then(m => m.DASHBOARD_ROUTES)
  ),
  createRoute(
    'support',
    import('./features/support/support-routing').then(m => m.SUPPORT_ROUTES)
  ),
  createRoute(
    'machines',
    import('./features/machines/machines-routing').then(m => m.MACHINE_ROUTES)
  ),
  createRoute(
    'analytics',
    import('./features/analytics/analytics-routes').then(m => m.ANALYTICS_ROUTES)
  ),
  createRoute(
    'connections',
    import('./features/connections/connections-routing').then(m => m.CONNECTIONS_ROUTES)
  ),
  {
    path: 'agin-connections',
    loadChildren: () =>
      import('./features/agin-connections/agin-connection-manager-routes').then(m => m.AGIN_CONNECTION_MANAGER_ROUTES),
    canLoad: [canLoadAginConnectionManagerRouteGuard],
  },
  createRoute(
    'configurations',
    import('./features/configurations/configurations-routing.module').then(m => m.CONFIG_ROUTES)
  ),
  createRoute(
    'shops',
    import('./features/shops/shops-routing').then(m => m.SHOP_ROUTES)
  ),
  createRoute(
    'parts-shop',
    import('./features/parts-shop/parts-shop-routes').then(m => m.PARTS_SHOP_ROUTES)
  ),
  createRoute(
    'dashboard',
    import('./features/dashboard/dashboard-routing').then(m => m.DASHBOARD_ROUTES)
  ),
  createRoute(
    'file-transfer',
    import('./features/file-transfer/file-transfer-routes').then(m => m.FILE_TRANSFER_ROUTES)
  ),
  createRoute(
    'license',
    import('./features/license/license-routes').then(m => m.LICENSE_ROUTES)
  ),
  createRoute(
    'notifications',
    import('./features/notifications/notifications-routes').then(m => m.NOTIFICATIONS_ROUTES)
  ),
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'analytics-reports/createReport',
    redirectTo: '/analytics/reports/createReport',
    pathMatch: 'full',
  },
  {
    path: 'analytics-reports/campaign-report/:id',
    redirectTo: '/analytics/reports/campaign-report/:id',
    pathMatch: 'full',
  },
  {
    path: 'analytics-reports/daily-reports/:id',
    redirectTo: '/analytics/reports/daily-reports/:id',
    pathMatch: 'full',
  },
  {
    path: 'analytics-reports',
    redirectTo: '/analytics/reports',
    pathMatch: 'full',
  },
  {
    path: 'analytics-comparison',
    redirectTo: '/analytics/comparison',
    pathMatch: 'full',
  },
  { path: 'server-error', component: ServerErrorComponent },
  createRoute(
    '**',
    import('./not-found/not-found-routing').then(m => m.NOT_FOUND_ROUTES)
  ),
];
